/**************************************************
 * Nombre:       Tarjeta_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import agave from '../../Recursos/Temporales/agave.svg'
import {FiberManualRecord} from '@mui/icons-material'
import {useNavigate} from "react-router";

const Tarjeta_Categorias = ({item}) => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: 'white', py: 4, px: 3}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 18, fontWeight: 800, lineHeight: 1.1}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-end'}}>
                <img src={agave} width={30}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{borderTop: 1, borderColor: '#00000050', pt: 2, mt: 2}}
            >

                {item && item.items.map((it, index) => (
                    <Grid container size={{xs: 12, sm: 12, md: item.md ? 6 : 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            onClick={() => navigate('/Catalogo/Categoria/'+it.nombre)}
                            sx={{
                            fontSize: 14,
                            fontWeight: 500, color: "#00000090", cursor: 'pointer',
                            '&:hover': {
                                color: '#000'
                            }
                        }}>
                            <FiberManualRecord sx={{width: 10, height: 10, pr: 1}}/>
                            {it.nombre}</Typography>
                    </Grid>
                ))}

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Categorias

